
import { Button } from "@/components/ui/button";
import { Wand2, Loader2, Sparkles } from "lucide-react";
import { ProgressLoading } from "@/components/ui/loading-states";

interface DocumentAIAssistantProps {
  isLoading: boolean;
  onAIAssist: () => void;
  progress?: number;
  hasAssessment?: boolean;
}

export function DocumentAIAssistant({ 
  isLoading, 
  onAIAssist, 
  progress = 0,
  hasAssessment = false 
}: DocumentAIAssistantProps) {
  return (
    <div className="relative">
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onAIAssist} 
        disabled={isLoading}
        className="relative gap-2"
      >
        {isLoading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : hasAssessment ? (
          <Sparkles className="w-4 h-4 text-yellow-500" />
        ) : (
          <Wand2 className="w-4 h-4" />
        )}
        {hasAssessment ? 'Smart AI Assist' : 'AI Assist'}
      </Button>
      
      {isLoading && progress > 0 && (
        <div className="absolute top-full left-0 mt-2 w-48 z-10">
          <div className="bg-white border rounded-md p-2 shadow-lg">
            <ProgressLoading 
              progress={progress} 
              message="Generating content..." 
            />
          </div>
        </div>
      )}
      
      {!hasAssessment && !isLoading && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-yellow-50 border border-yellow-200 rounded-md p-2 text-xs text-yellow-700 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
          💡 Complete your business assessment for personalized AI suggestions!
        </div>
      )}
    </div>
  );
}
